// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./dist/css/style.css
// module id = 5
// module chunks = 3